import { useState } from 'react';
import ReviewBlock from "../layout/review_block";
import PopUp from '../layout/popup';

import {reviews} from './placeholder/reviewData';

import WriteReview from '../layout/review_write';

import '../css/review.css';


function Review() {

    const [buttonPopUp, setButtonPopUp] = useState(false);


    return (

        <section id="Review">
            <div className="container review__container">
                <h1>Review</h1>
                <h2>What our Clients are saying</h2>

                <div className="review_content">
                    {reviews.map( (data) => {
                        return (
                            ReviewBlock(data)
                        )

                    })}

                </div>
                    
                <div className="link__write text_nofont">
                    <button className="btn"  onClick={() => setButtonPopUp(true) }>Write a review?</button>
                </div>

                <PopUp trigger={buttonPopUp} setTrigger={setButtonPopUp}>  
                    <WriteReview />
                </PopUp>
                
            </div>

        </section>

    );


}

export default Review;